import axios from "axios";
import Swal from "sweetalert2";
import store from "./store";
import routes from "./routes/router";

import {
  getBackendUrl,
  getReportUrl,
  getProtocolUrl,
  getStorageUrl,
} from "./components/api/localglobal.js";

const TooMany = () => {
  Swal.fire({
    icon: "error",
    title: "Вы слишком активны!",
    text: `Сервер остывает, подождите минуточку...`,
  });
};

const Err = () => {
  Swal.fire({
    icon: "error",
    title: "Сеанс пользователя завершен. ",
    text: "Время Вашей сессии истекло, для продолжения работы войдите в личный кабинет заново",
    preConfirm: () => {
      const router = routes(store.getters.role);
      store.dispatch("clear_user");
      location.pathname = "/login";
    },
  });
};

axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.post["Content-Type"] = "application/json; charset=utf-8";
axios.defaults.headers.get["Accept"] = "application/json";
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers.common["Access-Control-Allow-Methods"] =
  "GET, POST, PATCH, PUT, DELETE, OPTIONS";
axios.defaults.headers.common["Access-Control-Allow-Headers"] =
  "Origin, Content-Type, Authorization";

// axios.interceptors.response.use(
//   response => response,
//   error => {
//     if (typeof error.response === "undefined") {
//       Err();
//     }
//     return Promise.reject(error);
//   }
// );

export const token = localStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

export const expiration = localStorage.getItem("expiration");

const ErrorHendler = (error, ifError, url) => {
  const reg = /Request failed with status code 429/;
  const reg5 = /Request failed with status code 500/;
  const reg5url = /api\/protocolInfoByNumber/g;
  if (ifError) {
    ifError(error);
    return;
  }

  if (reg.test(error)) {
    TooMany();
    return error;
  } else if (reg5.test(error) && reg5url.test(url)) {
    store.commit("SET_PROCESSING", false);
    store.commit("SET_ERROR", error.message);
    return error;
  } else {
    store.commit("SET_PROCESSING", false);
    store.commit("SET_ERROR", error.message);
    ifError(error);
    return error;
  }
};

const ErrorHendlerProtocols = (error) => {
  store.commit("SET_PROCESSING", false);

  const netError = /Network Error/g;
  if (netError.test(error)) {
    store.commit("SET_PROCESSING", false);
    Swal.fire({
      icon: "warning",
      title: "Ошибка!",
      text: `Сервер offline!`,
    });
    return error;
  }

  return error;
};

const request = async (
  url,
  method,
  data = undefined,
  headers = undefined,
  timeout = 30000
) => {
  const config = { url, method };
  if (data) {
    config.data = data;
  }
  if (headers) {
    config.headers = headers;
  }
  if (timeout) {
    config.timeout = timeout;
  }

  return await axios.request(config);
};

export const sendRequest = async (
  url,
  method,
  data = undefined,
  ifError = Err,
  headers = undefined,
  timeout = 330000
) => {
  axios.defaults.baseURL = getBackendUrl();
  try {
    return await request(url, method, data, headers, timeout);
  } catch (error) {
    return ErrorHendler(error, ifError, url);
  }
};
export const sendRequestReport = async (
  url,
  method,
  data = undefined,
  ifError = undefined,
  headers = undefined
) => {
  axios.defaults.baseURL = getReportUrl();
  try {
    return await request(url, method, data, headers);
  } catch (error) {
    ErrorHendlerProtocols(error, ifError, url);
    return;
  }
};

export const sendRequestProtocols = async (
  url,
  method,
  data = undefined,
  ifError = undefined,
  headers = undefined
) => {
  axios.defaults.baseURL = getProtocolUrl();
  try {
    return await request(url, method, data, headers, 120000);
  } catch (error) {
    if (ifError !== undefined) {
      ifError(error);
      return;
    }

    ErrorHendlerProtocols(error);
    return;
  }
};

/**
 * Send request to file Storage service
 *
 * @params url: string, method: post|get|delete, data: FormData | JSON, CallBackFunction on error, Headers object
 * @return Promise with server data by this URL
 */

export const sendRequestFileStorage = async (
  url,
  method,
  data = undefined,
  ifError = Err,
  headers = undefined,
  responseType = undefined
) => {
  axios.defaults.baseURL = getStorageUrl();
  try {
    return await request(url, method, data, headers, responseType);
  } catch (error) {
    return ErrorHendler(error, ifError, url);
  }
};
